export default "__VITE_ASSET__w0A3uSau__"